import { createFetchReducer } from '../helpers/fetchData'
import actions from './actions'

const cardDesign = createFetchReducer({ name: actions.cardDesignApiName })

export default cardDesign
